import React, { useState, useRef, useEffect } from 'react';
import { Heart, ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import { weddingData } from '../mock';

export const HorizontalTimeline = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  const timelineEvents = weddingData.timeline;

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const scrollLeft = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      
      // Sur mobile, faire défiler le conteneur
      if (isMobile && scrollContainerRef.current) {
        const itemWidth = 280 + 16; // item width + gap
        scrollContainerRef.current.scrollTo({
          left: newIndex * itemWidth,
          behavior: 'smooth'
        });
      }
    }
  };

  const scrollRight = () => {
    if (currentIndex < timelineEvents.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      
      // Sur mobile, faire défiler le conteneur
      if (isMobile && scrollContainerRef.current) {
        const itemWidth = 280 + 16; // item width + gap
        scrollContainerRef.current.scrollTo({
          left: newIndex * itemWidth,
          behavior: 'smooth'
        });
      }
    }
  };

  const handleTouchScroll = (e) => {
    if (!isMobile) return;
    
    const container = scrollContainerRef.current;
    if (container) {
      const scrollLeft = container.scrollLeft;
      const itemWidth = 280 + 16; // item width + gap
      const newIndex = Math.round(scrollLeft / itemWidth);
      setCurrentIndex(Math.min(Math.max(newIndex, 0), timelineEvents.length - 1));
    }
  };

  return (
    <div className="horizontal-timeline-container">
      {/* Desktop Navigation buttons */}
      {!isMobile && (
        <>
          <button
            onClick={scrollLeft}
            disabled={currentIndex === 0}
            className="timeline-nav-button timeline-nav-left"
          >
            <ChevronLeft size={24} />
          </button>
          
          <button
            onClick={scrollRight}
            disabled={currentIndex === timelineEvents.length - 1}
            className="timeline-nav-button timeline-nav-right"
          >
            <ChevronRight size={24} />
          </button>
        </>
      )}

      {/* Timeline track */}
      <div className="horizontal-timeline-track">
        {/* Fixed continuous line with arrows */}
        <div className="horizontal-timeline-line-fixed">
          {/* Subtle arrows along the line */}
          <div className="timeline-arrow timeline-arrow-1">
            <ArrowRight size={16} />
          </div>
          <div className="timeline-arrow timeline-arrow-2">
            <ArrowRight size={16} />
          </div>
          <div className="timeline-arrow timeline-arrow-3">
            <ArrowRight size={16} />
          </div>
          <div className="timeline-arrow timeline-arrow-4">
            <ArrowRight size={16} />
          </div>
        </div>
        
        <div 
          ref={scrollContainerRef}
          className={`horizontal-timeline-events ${isMobile ? 'mobile-scroll' : ''}`}
          style={!isMobile ? {
            transform: `translateX(-${currentIndex * (100 / timelineEvents.length)}%)`
          } : {}}
          onScroll={handleTouchScroll}
        >
          {timelineEvents.map((event, index) => (
            <div key={index} className="horizontal-timeline-item">
              {/* Year on timeline - positioned differently on mobile */}
              <div className="timeline-year-on-track">{event.year}</div>
              
              {/* Heart icon */}
              <div className="horizontal-timeline-dot">
                <Heart size={16} className="text-white" />
              </div>
              
              {/* Card below */}
              <div className="horizontal-timeline-card">
                <p className="horizontal-timeline-description">{event.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile navigation buttons */}
      {isMobile && (
        <div className="timeline-mobile-navigation">
          <button
            onClick={scrollLeft}
            disabled={currentIndex === 0}
            className="timeline-nav-button timeline-nav-mobile"
          >
            <ChevronLeft size={20} />
          </button>
          
          <button
            onClick={scrollRight}
            disabled={currentIndex === timelineEvents.length - 1}
            className="timeline-nav-button timeline-nav-mobile"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      )}

      {/* Dots indicator */}
      <div className="timeline-dots-indicator">
        {timelineEvents.map((_, index) => (
          <button
            key={index}
            onClick={() => {
              setCurrentIndex(index);
              // Sur mobile, faire défiler le conteneur
              if (isMobile && scrollContainerRef.current) {
                const itemWidth = 280 + 16; // item width + gap
                scrollContainerRef.current.scrollTo({
                  left: index * itemWidth,
                  behavior: 'smooth'
                });
              }
            }}
            className={`timeline-dot-button ${index === currentIndex ? 'active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};